export interface NotificationLinkSource {
  type?: string | null;
  message?: string | null;
}

export interface NotificationTarget {
  userId: number;
  route: string;
  labelKey: "OEM" | "supplier";
}

const getTargetUserIdFromMessage = (message?: string | null): number | null => {
  const match = String(message || "").match(/utilisateur\s*#\s*(\d+)/i);
  if (!match) return null;

  const userId = Number(match[1]);
  return Number.isFinite(userId) && userId > 0 ? userId : null;
};

const getTargetKind = (notification: NotificationLinkSource) => {
  const text = `${notification.type || ""} ${notification.message || ""}`.toLowerCase();

  if (/\boem\b/.test(text)) return "oem";
  if (text.includes("fournisseur") || text.includes("supplier")) return "supplier";

  return null;
};

export const getNotificationTarget = (
  notification: NotificationLinkSource,
): NotificationTarget | null => {
  const userId = getTargetUserIdFromMessage(notification.message);
  const kind = getTargetKind(notification);

  if (!userId || !kind) return null;

  if (kind === "oem") {
    return {
      userId,
      route: `/oem-profile/${userId}`,
      labelKey: "OEM",
    };
  }

  return {
    userId,
    route: `/profileSupplier/${userId}`,
    labelKey: "supplier",
  };
};

export const getNotificationRoute = (notification: NotificationLinkSource) =>
  getNotificationTarget(notification)?.route || "/notifications";
